import * as Yup from 'yup';

export const cancelPackageSchemasHelper = (t: any) => {
  return Yup.object({
    reason: Yup.string().required(t('CANCEL_PACKAGE_MODAL.REASON_REQUIRED'))
  })
}